import React from 'react';
import Welcome from '../components/Welcome';

const WelcomePage = () => {
  return (
    <div className="min-h-screen w-full outline-none">
      <Welcome />
    </div>
  );
};

export default WelcomePage;